<template>
  <div class="modal-frame modal-medium" :class="{active:isOpen}" data-modal="download-dates">
    <div class="modal-frame-content">
      <button @click="$emit('close')" class="btn-close" rel="button_close" type="button" data-modal-close>
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <div class="modal-frame-header">
        <div class="h3">Загрузить фотографии</div>
      </div>
      <div class="modal-frame-body">
        <div class="download-zone" ref="dropzoneElement">
          <div class="progress-group-list" v-if="fileDocs.length > 0">
            <div class="progress-group" v-for="(file, index) in fileDocs" :key="index">
              <div class="progress-title">
                <p class="font-16">{{ file.name }} <span class="muted-14">{{ formatFileSize(file.size) }}</span></p>
                <button class="progress-cansel" @click="removeFile(index)">
                  <svg class="svg-cross">
                    <use href="/img/sprite.svg#svg-cross"></use>
                  </svg>
                </button>
              </div>
              <div class="progress-line-group">
                <div class="progress-status">
                  <svg v-if="file.progress === 100" class="svg-check-fill">
                    <use href="/img/sprite.svg#svg-check-fill"></use>
                  </svg>
                  <div v-else class="font-11">{{ file.progress }}%</div>
                </div>
                <div class="progress-line">
                  <span :style="{ width: file.progress + '%' }"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center" v-if="fileDocs.length > 0">
            <a class="add-link link-dotted-icon" href="#!" @click.prevent="openFileDialog">
              <svg class="svg-plus">
                <use href="/img/sprite.svg#svg-plus"></use>
              </svg>
              <span class="fonts-14">Добавить еще</span>
            </a>
          </div>
          <div class="download-zone-box">
            <div class="download-icon">
              <svg class="svg-load">
                <use href="/img/sprite.svg#svg-load"></use>
              </svg>
            </div>
          </div>
          <div class="download-zone-text attachment-button" v-if="fileDocs.length === 0">
            <p>Перетащите файл в эту область или
              <a href="#!" class="txt-accent" @click.prevent="openFileDialog">выберите для загрузки</a>
            </p>
            <div class="download-zone-conditions">
              <span class="muted-13">Допустимые форматы: .jpg, .png, .jpeg, .bmp, .webp</span>
              <span class="muted-13">Не более 2 Мб</span>
            </div>
          </div>
        </div>
        <div class="download-zone-note font-14 mgt-20">
          <div class="error-message" v-if="serverError">
            <span v-html="serverError"></span>
          </div>

          <div class="success-message" v-if="successMessage">
            <span v-html="successMessage"></span>
          </div>


        <div v-if="fileDocs.length > 0" class="inner-box"><button @click="saveFiles" :class="{loader: isSubmitting}" class="btn" type="button">Сохранить</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Dropzone } from 'dropzone';
import 'dropzone/dist/dropzone.css';
import {mapActions} from "vuex";

export default {
  emits: ['close', 'saved'],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    id: false
  },
  data: () => ({
    fileDocs: [],
    fileIds: [],
    dropzoneInstance: null,
    isSubmitting: null,
    serverError: null,
    successMessage: null,
  }),
  mounted() {
    this.initDropzone();
  },
  beforeUnmount() {
    if (this.dropzoneInstance) {
      this.dropzoneInstance.destroy();
    }
  },
  methods: {
    ...mapActions('positions', [
      'setFilePositions',
    ]),
    initDropzone() {
      this.dropzoneInstance = new Dropzone(this.$refs.dropzoneElement, {
        url: axios.defaults.baseURL + 'api/order/file/',
        method: "post",
        disablePreviews: true,
        autoProcessQueue: true,
        clickable: false,
        maxFilesize: 2,
        acceptedFiles: '.png,.jpg,.jpeg,.bmp,.gif,.webp',
        addRemoveLinks: false,
        autoQueue: true
      });

      this.dropzoneInstance.on('addedfile', (file) => {
        const fileData = {
          name: file.name,
          size: file.size,
          progress: 0,
          file: file,
          id: null
        };
        this.fileDocs.push(fileData);
      });

      this.dropzoneInstance.on('uploadprogress', (file, progress) => {
        const fileData = this.fileDocs.find(f => f.file === file);
        if (fileData) {
          fileData.progress = Math.round(progress);
        }
      });

      this.dropzoneInstance.on('success', (file, response) => {
        const fileData = this.fileDocs.find(f => f.file === file);
        if (fileData && response.data && response.data.file) {
          fileData.progress = 100;
          fileData.id = response.data.file.id;
          fileData.link = response.data.file.link;
          fileData.filename = response.data.file.filename;
          fileData.format_size = response.data.file.format_size;
          fileData.save = response.data.file.save;

          // Добавляем ID в массив для дальнейшего использования
          this.fileIds.push(response.data.file.id);

          console.log('Uploaded file ID:', response.data.file.id);
          console.log('All file IDs:', this.fileIds);
        }
      });

      this.dropzoneInstance.on('error', (file, errorMessage) => {
        const index = this.fileDocs.findIndex(f => f.file === file);
        if (index !== -1) {
          this.fileDocs.splice(index, 1);
        }
        console.error('Upload error:', errorMessage);
      });
    },

    openFileDialog() {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.accept = '.xls,.doc,.pdf,.xlsx,.docx';

      input.addEventListener('change', (e) => {
        const files = e.target.files;
        if (files.length > 0) {
          Array.from(files).forEach(file => {
            this.dropzoneInstance.addFile(file);
          });
        }
      });

      input.click();
    },

    removeFile(index) {
      const fileData = this.fileDocs[index];
      if (fileData) {
        // Удаляем ID из массива fileIds
        if (fileData.id) {
          const idIndex = this.fileIds.indexOf(fileData.id);
          if (idIndex !== -1) {
            this.fileIds.splice(idIndex, 1);
            console.log('Removed file ID:', fileData.id);
            console.log('Remaining file IDs:', this.fileIds);
          }
        }

        // Удаляем файл из Dropzone
        if (fileData.file) {
          this.dropzoneInstance.removeFile(fileData.file);
        }
      }

      // Удаляем из списка отображаемых файлов
      this.fileDocs.splice(index, 1);
    },

    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' Kb';
      return Math.round(bytes / (1024 * 1024)) + ' Mb';
    },

    // Метод для получения всех ID загруженных файлов
    getUploadedFileIds() {
      return this.fileIds;
    },

    async saveFiles() {
      this.isSubmitting = true;
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {
        files: this.getUploadedFileIds(),
      };

      try {

        let url = `/api/position/file/save/${this.id}/`;

        // отправка данных на сервер
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.setFilePositions({files: response.data.data, id: this.id});
          this.$emit('saved', {files: response.data.data, id: this.id});
          this.fileDocs = [];
          this.fileIds = [];
            this.successMessage = 'Файлы сохранены';
            setTimeout(() => {
              this.successMessage = null;
            }, 5000);
        }

      } catch (error) {
        this.serverError = error;
        //this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>
